import type { ButtonSizes } from "../components/Button/Button/types";
import type { IndicatorSize } from "../components/Indicator/Indicator/types";

export const buttonSizeToAssetSizeDict = {
    "56": "24",
    "44": "24",
    "36": "20",
    "28": "16",
} as const;

export const buttonCircleSizeToAssetSizeDict = {
    "56": "24",
    "44": "24",
    "36": "20",
    "28": "16",
    "24": "16",
    "20": "12",
    "16": "12",
} as const;

export const assetSizeToButtonSizeDict = {
    "24": ["56", "44"],
    "20": "36",
    "16": "28",
};

export const buttonSizeToCounterSizeDict = {
    "56": "16",
    "44": "16",
    "36": "12",
    "28": "8",
} as const;

export const buttonCircleSizeToCounterSizeDict = {
    "56": "16",
    "44": "16",
    "36": "12",
    "28": "8",
    "24": "8",
    "20": "8",
    "16": "8",
} as const;

export const buttonSizeToIndicatorSizeDict: Record<ButtonSizes, IndicatorSize> =
    {
        "28": "8",
        "36": "12",
        "44": "12",
        "56": "12",
    };
